import React, { useEffect } from 'react';
import confetti from 'canvas-confetti';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { CheckCircle2, Flame, ChevronRight } from 'lucide-react';

const prefersReducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

export const StreakChip = ({ streak }) => {
  if (!streak) return null;
  return (
    <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-orange-500/20 text-orange-200 text-xs font-semibold" title={`${streak}-day learning streak`} data-testid="player-streak-chip">
      <Flame className="h-3.5 w-3.5 text-orange-400" /> {streak}
    </span>
  );
};

// Short, encouraging celebration shown when a learner completes a module
export const ModuleCelebration = ({ data, onContinue, onClose }) => {
  useEffect(() => {
    if (!data || prefersReducedMotion()) return;
    confetti({ particleCount: 90, spread: 70, origin: { y: 0.6 }, colors: ['#20acf6', '#02d1d4', '#22c55e', '#f59e0b'], disableForReducedMotion: true });
  }, [data]);

  return (
    <Dialog open={!!data} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-sm text-center" data-testid="module-celebration">
        <div className="mx-auto w-14 h-14 rounded-full bg-green-100 flex items-center justify-center">
          <CheckCircle2 className="h-8 w-8 text-green-600" />
        </div>
        <DialogTitle className="text-xl text-[#2a3e5d]">Module complete!</DialogTitle>
        <DialogDescription className="text-slate-600" data-testid="celebration-module-title">
          Great work finishing <strong>{data?.moduleTitle}</strong>.
        </DialogDescription>
        <div className="space-y-3 mt-1">
          <div>
            <div className="flex justify-between text-xs text-slate-500 mb-1"><span>Course progress</span><span data-testid="celebration-progress">{data?.progressPct}%</span></div>
            <div className="h-2 bg-slate-100 rounded-full overflow-hidden"><div className="h-full bg-[#20acf6] rounded-full" style={{ width: `${data?.progressPct || 0}%` }} /></div>
          </div>
          {data?.streak > 0 && (
            <p className="inline-flex items-center gap-1.5 text-sm font-medium text-orange-600" data-testid="celebration-streak">
              <Flame className="h-4 w-4" /> {data.streak}-day learning streak — keep it going!
            </p>
          )}
        </div>
        <Button onClick={onContinue} className="w-full bg-[#20acf6] hover:bg-[#3bb8f7] min-h-[44px] mt-2" data-testid="celebration-continue-btn">
          {data?.hasNext ? <>Continue <ChevronRight className="h-4 w-4 ml-1" /></> : 'Close'}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
